import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { StoryblokLinkDirective } from 'src/app/directive/storyblok-link.directive';

@Component({
    selector: 'app-message',
    imports: [CommonModule, RouterModule, StoryblokDirective, StoryblokLinkDirective],
    templateUrl: './message.component.html',
    styleUrl: './message.component.scss'
})
export class MessageComponent implements OnInit {
  @Input() message!: string;
  @Input() colour!: { color: string };
  @Input() background!: { color: string };
  @Input() link!: any;
  @Input() _editable!: string;

  @Input() _uid!: string;
  @Input() component!: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    if (this.colour?.color) {
      this.renderer.setStyle(this.el.nativeElement, 'color', this.colour.color);
    }
    if (this.background?.color) {
      this.renderer.setStyle(
        this.el.nativeElement,
        'background',
        this.background.color
      );
    }
  }
}
